import React from "react";

export default function BottomMenu({ view, onNavigate }) {
  const isActive = (key) => view === key;

  const buttonStyle = (active) => ({
    backgroundColor: "black",
    border: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontSize: "0.85rem",
    color: active ? "#4e8cff" : "white",
    fontWeight: active ? "bold" : "normal",
    cursor: "pointer",
  });

  const iconStyle = (active) => ({
    width: "24px",
    height: "24px",
    marginBottom: "0.25rem",
    fill: active ? "#4e8cff" : "white",
  });

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "#000",
        borderTop: "1px solid rgb(19 20 20)",
        display: "flex",
        justifyContent: "space-around",
        padding: "0.75rem 0",
        boxShadow: "0 -1px 3px rgba(0,0,0,0.1)",
        zIndex: 1000,
      }}
    >
      <button onClick={() => onNavigate("contacts")} style={buttonStyle(isActive("contacts"))}>
        <svg viewBox="0 0 24 24" style={iconStyle(isActive("contacts"))}>
          <path d="M20 2H4C2.9 2 2 2.9 2 4v14l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
        </svg>
        Chats
      </button>

      <button onClick={() => onNavigate("new_chat")} style={buttonStyle(isActive("new_chat"))}>
        <svg viewBox="0 0 24 24" style={iconStyle(isActive("new_chat"))}>
          <path d="M12 5v14M5 12h14" stroke={isActive("new_chat") ? "#4e8cff" : "white"} strokeWidth="2" fill="none" />
        </svg>
        New Chat
      </button>

      <button onClick={() => onNavigate("settings")} style={buttonStyle(isActive("settings"))}>
        <svg viewBox="0 0 24 24" style={iconStyle(isActive("settings"))}>
          <path d="M12 15.5c1.93 0 3.5-1.57 3.5-3.5S13.93 8.5 12 8.5 8.5 10.07 8.5 12s1.57 3.5 3.5 3.5z" />
          <path d="M19.43 12.98a7.998 7.998 0 0 0 0-1.96l2.11-1.65a.5.5 0 0 0 .12-.65l-2-3.46a.5.5 0 0 0-.61-.22l-2.49 1a7.963 7.963 0 0 0-1.69-.98l-.38-2.65a.5.5 0 0 0-.5-.42h-4a.5.5 0 0 0-.5.42l-.38 2.65c-.6.22-1.16.52-1.69.98l-2.49-1a.5.5 0 0 0-.61.22l-2 3.46a.5.5 0 0 0 .12.65L4.57 11c-.05.32-.07.65-.07.98s.02.66.07.98l-2.11 1.65a.5.5 0 0 0-.12.65l2 3.46a.5.5 0 0 0 .61.22l2.49-1c.53.46 1.09.76 1.69.98l.38 2.65a.5.5 0 0 0 .5.42h4a.5.5 0 0 0 .5-.42l.38-2.65c.6-.22 1.16-.52 1.69-.98l2.49 1a.5.5 0 0 0 .61-.22l2-3.46a.5.5 0 0 0-.12-.65l-2.11-1.65z" />
        </svg>
        Settings
      </button>
    </div>
  );
}